import { css } from "styled-components";
export const ctaCursorMixin = css `
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
`;
export const ctaTransitionEffectMixin = css `
  transition:
    color 0.25s ease-in-out,
    background-color 0.3s ease-in-out;
`;
//# sourceMappingURL=mixins.js.map